// Mock data for the Incarcerated clone (frontend-only phase)

export const NAV_LINKS = [
  { label: "HOME", to: "/" },
  { label: "COMMUNITY", to: "/community" },
  { label: "CONTACT US", to: "/contact" },
  { label: "DONATE", to: "/donate" },
];

export const HERO = {
  title: "INCARCERATED",
  image:
    "https://images.unsplash.com/photo-1705918338987-109019c0464a",
  imageAlt:
    "Silhouette of hands reaching through prison bars in dramatic lighting",
  paragraphs: [
    "Searching for a loved one or friend? Need information about someone serving a prison sentence? Finding the right information can be difficult, but you don\u2019t have to search alone.",
    "Our website is designed to help you find useful information quickly and easily. Please join our forum and help those in need of answers or even post your experiences. We regularly update our site, so make sure you check back often for the latest information.",
    "Thank you for visiting \u2014 we hope you find the answers you\u2019re looking for.",
  ],
};

export const STORY_HEADING = "I SPENT 10 YEARS IN 10 DIFFERENT PRISONS";

export const FEATURES = [
  {
    title: "UPLOAD HERE",
    subtitle: "Videos / Letters / Pictures",
    description:
      "Share your videos, letters and pictures with the community, or view what other members have uploaded.",
    cta: "VIEW HERE",
    to: "/your-story",
    image:
      "https://images.unsplash.com/photo-1761236301545-e0d533b3669b",
  },
  {
    title: "THE E-BOOK",
    subtitle: "10 Years in 10 Prisons",
    tagline: "New Book: Life After the Gates",
    description:
      "Read both e-books here today.",
    cta: "GET THE E-BOOKS",
    to: "/e-book",
    image:
      "https://i0.wp.com/incarcerated.com.au/wp-content/uploads/2026/09/my-book.png?fit=683%2C1024&ssl=1",
    image2: "/images/life-after-the-gates.jpg",
    image2Alt: "Life After the Gates – new book by Rocky Roccisano",
  },
  {
    title: "COMMUNITY",
    subtitle: "Social Network",
    description:
      "Join the community, share your experiences, ask questions and connect with people today.",
    cta: "JOIN THE COMMUNITY",
    to: "/community",
    image:
      "https://images.unsplash.com/photo-1587297415761-a2e2697a1330",
  },
  {
    title: "MERCHANDISE",
    subtitle: "Purchase yours today",
    description:
      "Official Incarcerated merchandise. Wear your support and help keep this community growing.",
    cta: "PURCHASE YOURS TODAY",
    to: "/merchandise",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_prison-preview/artifacts/bc8195a7fb2590c1_shirts.png",
  },
];

export const INFO_CARDS = [
  {
    title: "PRISONS",
    description: "Explore information about prisons across Queensland.",
    cta: "PRISONS",
    to: "/prisons",
  },
  {
    title: "DAILY LIFE",
    description: "A guide to what life inside looks like day to day.",
    cta: "DAILY LIFE",
    to: "/daily-life",
  },
  {
    title: "THE GUARDS",
    description:
      "An inside look at the officers and staff who run Australia\u2019s prisons.",
    cta: "THE GUARDS",
    to: "/the-guards",
  },
  {
    title: "PRISON SLANG",
    description:
      "Decode the language of prison \u2014 a guide to the slang used inside.",
    cta: "PRISON SLANG",
    to: "/prison-slang",
  },
  {
    title: "MAINSTREAM OR PROTECTION",
    description:
      "Understanding the difference between mainstream and protection custody inside Australian prisons.",
    cta: "MAINSTREAM OR PROTECTION",
    to: "/main-or-protection",
  },
  {
    title: "LOCATE A PRISONER",
    description:
      "A link to help search for a prisoner currently serving a sentence in Queensland correctional facilities. We do not hold or give out personal information. You must know their details to access.",
    cta: "LOCATE A PRISONER",
    to: "/locate-a-prisoner",
  },
  {
    title: "EMAIL A PRISONER",
    description:
      "A link to help send an email and payment to a prisoner in a Queensland correctional center. We do not give out or hold personal information. You must know the prisoners details.",
    cta: "EMAIL A PRISONER",
    to: "/email-a-prisoner",
  },
  {
    title: "DAILY LAW COURTS LIST",
    description:
      "A link to help access information in the daily Queensland law courts list. Information to help find scheduled hearings and appearances. We do not hold or give out any personal details.",
    cta: "DAILY LAW COURTS LIST",
    to: "/daily-law-courts-list",
  },
];

export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/", icon: "facebook" },
  { label: "YouTube", href: "https://www.youtube.com/", icon: "youtube" },
  { label: "Twitter", href: "https://twitter.com/", icon: "twitter" },
  { label: "Instagram", href: "https://instagram.com/", icon: "instagram" },
];

// Mock forum data (used before backend is wired)
export const MOCK_CATEGORIES = [
  { id: "general", name: "General Discussion", description: "Talk about anything related to incarceration in Australia." },
  { id: "support", name: "Support & Advice", description: "Ask questions and get help from people who understand." },
  { id: "experiences", name: "Your Experiences", description: "Share your story of life inside or supporting someone inside." },
];

export const MOCK_TOPICS = [
  {
    id: "t1",
    category: "support",
    title: "How do I locate someone recently sentenced in QLD?",
    author: "Sarah_M",
    createdAt: "2026-09-20T10:30:00Z",
    replies: 4,
    body: "My brother was sentenced last week and I have no idea which facility he was sent to. Any advice on how to find out?",
  },
  {
    id: "t2",
    category: "experiences",
    title: "First visit tomorrow \u2014 what should I expect?",
    author: "WaitingWife",
    createdAt: "2026-09-18T14:05:00Z",
    replies: 7,
    body: "I have my first ever prison visit tomorrow and I'm really nervous. What do I need to bring and what are the rules?",
  },
  {
    id: "t3",
    category: "general",
    title: "Understanding the difference: mainstream vs protection",
    author: "AdminMike",
    createdAt: "2026-09-15T08:00:00Z",
    replies: 12,
    body: "A lot of people ask about this so I thought I'd start a thread. Feel free to share your understanding.",
  },
];
